export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11921.93bf5e9f.jpg";